import React, { type FC } from 'react';

import ChevronRightIcon from '@atlaskit/icon/core/chevron-right';
import LinkExternal from '@atlaskit/icon/core/link-external';
import Link from '@atlaskit/link';
import { Text, Pressable, xcss, Flex, Box } from '@atlaskit/primitives';
import { token } from '@atlaskit/tokens';

const pressableStyles = xcss({
	':hover': {
		textDecoration: 'underline',
	},
});

type SubtleLinkProps = {
	href?: string;
	onClick?: () => void;
	onClickDisabled?: boolean;
	children?: React.ReactNode;
	analyticsContext?: Record<string, any>;
};

export const SubtleLink: FC<SubtleLinkProps> = ({
	href,
	children,
	onClick,
	onClickDisabled = false,
	analyticsContext,
}) => {
	const linkContent = (
		<Text color="color.text.subtle">
			<Flex alignItems="center" gap="space.150">
				{children}
				{href ? (
					<LinkExternal label="" color={token('color.icon.subtlest')} />
				) : (
					<ChevronRightIcon label="" color={token('color.icon.subtlest')} />
				)}
			</Flex>
		</Text>
	);

	return href ? (
		<Box padding="space.100">
			<Link appearance="subtle" href={href} analyticsContext={analyticsContext} onClick={onClick}>
				{linkContent}
			</Link>
		</Box>
	) : (
		<Pressable
			onClick={onClick}
			analyticsContext={analyticsContext}
			padding="space.100"
			backgroundColor="color.background.neutral.subtle"
			xcss={pressableStyles}
			isDisabled={onClickDisabled}
		>
			{linkContent}
		</Pressable>
	);
};
